<div class="counter-box">
  @if (configs.link) {
    <a
      class="menu-link"
      [routerLink]="configs.link.routerLink"
      [queryParams]="configs.link.queryParams"
      routerLinkActive="active"
    >
      <ng-container *ngTemplateOutlet="counterBox"></ng-container>
    </a>
  } @else {
    <ng-container *ngTemplateOutlet="counterBox"></ng-container>
  }
</div>

<ng-template #counterBox>
  <div class="counter-value">
    <span>{{ configs.content.value }}</span>
    @if (configs.content.icon) {
      <i [ngClass]="configs.content.icon"></i>
    }
  </div>
  <div 
    class="counter-text"
    [ngClass]="configs.content.titleClass"
  >
    {{ configs.content.title | translate }}
  </div>
  @if (actions.length > 0) {
    <div class="action">
      @for (elem of actions; track elem) {
        <i
          [ngClass]="elem.icon"
          (click)="elem.click()"
          [tooltip]="elem.tooltip | translate"
          container="body"
        ></i>
      }
    </div>
  }

</ng-template>
